export default "__VITE_ASSET__iFxbjCY3__"